import { useContext } from 'react'
import UserContext from '../contexts/UserContext'
import { canEditStock, hasModulePermission } from '../config/modulesByTenant'

interface ModuleConfig {
  name: string
  path: string
  image: string
  section: string
  permission: string
  dependencies?: string[]
}

export const usePermissions = () => {
  const { user } = useContext(UserContext)

  const hasPermission = (permission: string, dependencies: string[] = []): boolean => {
    if (!user.permissions) return false

    // Se tem a permissão principal, automaticamente tem acesso (dependências auto-concedidas)
    return user.permissions.includes(permission)
  }

  const canEdit = {
    stock: (): boolean => canEditStock(user.permissions || []),
    certificates: (): boolean => hasPermission('certificates'),
    production: (): boolean => hasPermission('production'),
    orders: (): boolean => hasPermission('orders'),
    router: (): boolean => hasPermission('router'),
    accesses: (): boolean => hasPermission('accesses'),
    products: (): boolean => hasPermission('products'),
    resources: (): boolean => hasPermission('resources'),
    services: (): boolean => hasPermission('services'),
    equipment: (): boolean => hasPermission('equipment')
  }

  const canView = {
    stock: (): boolean => hasPermission('stock'),
    certificates: (): boolean => hasPermission('certificates'),
    production: (): boolean => hasPermission('production'),
    orders: (): boolean => hasPermission('orders'),
    router: (): boolean => hasPermission('router'),
    accesses: (): boolean => hasPermission('accesses'),
    products: (): boolean => hasPermission('products'),
    resources: (): boolean => hasPermission('resources'),
    services: (): boolean => hasPermission('services'),
    equipment: (): boolean => hasPermission('equipment')
  }

  return {
    hasPermission,
    canEdit,
    canView,
    userPermissions: user.permissions || []
  }
}
